import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { v_LocationDetailBus } from "./v_LocationDetailBus";
import { v_InventoryBus } from "./v_InventoryBus";

export class DispatchCustPartsBus extends BaseBus {
    constructor(busObj: BaseBus = null) {
        super(busObj);
        this.insertDt = DateFunctions.getDate(this.insertDt);
        this.updateDt = DateFunctions.getDate(this.updateDt);
        this.eta = DateFunctions.getDate(this.eta);
    }
    CID(): any {
        return this.dispatchCustPartId;
    }
    setId(id: any) {
        this.dispatchCustPartId = id;
    }
    setParentId(id: any) {
        this.dispatchId = id;
    }
    //setFromForm(busObj: any) {
    //    super.setFromForm(busObj);
    //}
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: v_LocationDetailBus = null) {
        this.quantity = 1;
        this.rcvdPersonId = personId;
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!DateFunctions.isValidDate(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
        this.eta = DateFunctions.getDateTimeWithUTCOffset(this.eta);
    }
    changeInventoryItem(data: v_InventoryBus) {
        this.inventoryNumber = data.number;
        this.inventoryId = data.inventoryId;
        this.partInfo = data.fullDescription;
    }
    dispatchCustPartId: any;
    dispatchId: any;
    refNbr: string;
    eta: Date;
    isRcvd: boolean;
    rcvdPersonId: any;
    quantity: number;
    partInfo: string;
    supplierId: any;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
    qtyRcvd: number;
    personName: string;
    inventoryId: any;
    inventoryNumber: string;
    qtyUsed: number;
    note: string;
    reducedPartNote: string;
}